import config from '../../config.js';
export default {
    methods: {
        recaptchaGetKey: async function() {
            if (!!config.recaptchaClientKey) {
                // (optional) Wait until recaptcha has been loaded.
                await this.$recaptchaLoaded() 

                // Execute reCAPTCHA with action "login".
                return await this.$recaptcha('login')
            }
            return ""
        }
    }
}